<template>
  <b-card
    title="مدیریت بودجه ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 ml-1"
                variant="primary"
                @click="addBudget()"
              >
                جدید
              </b-button>
              <b-button
                variant="success"
                class="mb-1 mr-auto ml-1"
                @click="clearCache"
              >
                بروزرسانی
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                    label="نوع کالا"
                    label-for="DivisionId"
                >
                  <z-division
                      v-model="filterOptions.DivisionId"
                      :multiple="false"
                      :clearable="true"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                  label="سبک"
                  label-for="StyleId"
                >
                  <z-style
                    v-model="filterOptions.StyleId"
                    :multiple="false"
                    :clearable="true"
                    :division-id="filterOptions.DivisionId"
                  />
                </b-form-group>
              </b-col>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updateBudget(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Division)="data">
            <b-badge
              variant="light-primary"
            >
              {{ data.item.Style.Division.Title }}
            </b-badge>
          </template>

          <template #cell(Style)="data">
            <b-badge
              variant="light-info"
            >
              {{ data.value.Title }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link @click="updateBudget(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showBudgetModal"
      v-model="showBudgetModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="جزئیات سبک"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="save"
    >

      <b-col md="12">
        <b-form-group
          label="عنوان"
          label-for="Title"
        >
          <b-form-input
            id="Title"
            v-model="row.Title"
            autocomplete="off"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
          label="نوع کالا"
          label-for="DivisionId"
        >
          <z-division
            v-model="row.DivisionId"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
          label="سبک"
          label-for="StyleId"
        >
          <z-style
              v-model="row.StyleId"
                   :division-id="row.DivisionId"
                   :disabled="!row.DivisionId" />
        </b-form-group>
      </b-col>

    </b-modal>
  </b-card>
</template>

<script>
import ZStyle from '@/tools/style.vue'
import ZDivision from '@/tools/division.vue'

export default {
  name: 'Budget',
  components: { ZStyle, ZDivision },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        StyleId: null,
      },
      showBudgetModal: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Division',
          label: 'نوع کالا',
        },
        {
          key: 'Style',
          label: 'سبک',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.budget.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
        this.$api.budget.clearcache, null,
      )
        .then(res => {
          this.update()
        })
    },
    save() {
      let url = this.$api.budget.add
      if (this.row.Id) {
        url = this.$api.budget.update
      }

      this.$http.post(
        url, this.row,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showBudgetModal = true
        })
    },
    addBudget() {
      this.row = { Title: null, StyleId: null, DivisionId: null }
      this.showBudgetModal = true
    },
    updateBudget(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.row.StyleId = this.row.Style.Id
      this.row.DivisionId = this.row.Style.Division.Id
      this.showBudgetModal = true
    },
    remove(id) {
      this.removeRow(this.$api.budget.remove, 'Id', id)
    },
  },
}
</script>

<budget scoped>

</budget>
